import api from "../..";
import type { ApiResponse } from "../../types";
import type { ArticleDetail, PatchArticleParams } from "./types";

export const patchArticle = async ({ slugOrId, body }: PatchArticleParams): Promise<boolean> => {

  return await api.patch<ApiResponse<ArticleDetail>>(`/article/${slugOrId}/`, body)
  .then(() => true)
  .catch(() => false);
};
